export default {
  GET_SCHEDULE: 'OFFICE_GET_SCHEDULE',
  SAVE_SCHEDULE: 'OFFICE_SAVE_SCHEDULE'
}